import React, { useState, useEffect, useContext }  from "react";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { LanguageContext } from "../App";
import { buildAccountJsonBody, buildProsArray, buildOrgsArray, accountNameLoaded } from "../utils/accountBody";

var baseUrl = "https://cognitunerdev.azurewebsites.net";

var eulaAccepted = false;
var eulaUserId = null;
var eulaToken = null;
var eulaUsername = null;
var eulaRole = null;
var eulaOrg = null;
var eulaOrgs = null;
var eulaLanguage = null;
var eulaEmail = null;
var eulaExpires = null;
var eulaSettings = null;

var token = null;
var userLanguage = localStorage.getItem("userLanguage");
var userId = null;
var userExpires = null;
var username = null;
var org = null;
var orgs = null;
var role = null;
var userSettingsIds = null;
var userEmail = null;

var loggedIn = false;

function setAuthStyle(setTwoStepStyle, twoStepStyle) {
  var authApp = document.getElementById("authApp");
  var authEmail = document.getElementById("authEmail");

  if (authApp !== undefined && authApp !== null &&
    authEmail !== undefined && authEmail !== null) {

    if (authEmail.checked) {
      setTwoStepStyle("email");
    }
    else if (authApp.checked) {
      setTwoStepStyle("auth");
    }
  }
}

const Authoritize = () => {
  if (localStorage.getItem("token") !== null) {
    token = localStorage.getItem("token");
  }

  if (localStorage.getItem("userId") !== null) {
    userId = localStorage.getItem("userId");
  }

  const authEmailSentOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_auth_email_sent")}</h1>
        <button className="confirmButton" onClick={onClose}>Ok</button>
      </div>,
    willUnmount: () => {}
  }

  const authEmailFailedOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_failed_to_send_auth_email")}</h1>
        <button className="confirmButton" onClick={onClose}>Ok</button>
      </div>,
    willUnmount: () => {}
  }

  const tokenExpiredOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_token_expired")}</h1>
        <button className="confirmButton" onClick={removeTokenAndRefresh}>{t("local_refresh_page")}</button>
      </div>,
    closeOnClickOutside: false,
    willUnmount: () => {}
  }

  const [twoStepStyle, setTwoStepStyle] = useState("none");
  const [verificationCode, setVerificationCode] = useState('');

  const checkUserData = async () => {
    if (localStorage.getItem("token") !== null) {
      token = localStorage.getItem("token");
    }

    if (localStorage.getItem("userId") !== null) {
      userId = localStorage.getItem("userId");
    }

    if (token !== "null" && token !== null && token !== undefined && token) {
      try {
        const response = await fetch(baseUrl + "/api/v1/account/" + userId,
        {
          headers: { "Authorization": "Bearer " + token },
        });

        console.log(response);

        if (response.status === 403) {
          confirmAlert(tokenExpiredOptions);
        }
        else if (response.status === 200) {
          const data2 = await response.json();

          if (data2.twostep === true) {
            if (data2.full_name !== null && data2.full_name !== undefined) {
              localStorage.setItem("username", data2.full_name);
            }
            else {
              localStorage.removeItem("username");
            }

            if (localStorage.getItem("token") === null) {
              localStorage.setItem("token", token);
            }

            localStorage.setItem("role", data2.role);
            localStorage.setItem("org", data2.orgs[0]);
            localStorage.setItem("orgs", data2.orgs);
            localStorage.setItem("userId", data2.user_id);
            localStorage.setItem("userLanguage", data2.locale.toLowerCase());
            localStorage.setItem("userEmail", data2.email);
            localStorage.setItem("userExpires", data2.expires);
            var settings3 = data2.settings;

            if (settings3 !== null && settings3.substring(settings3.indexOf("[") + 1, settings3.indexOf("[") + 2) === '"') {
              localStorage.setItem("userSettingsIds", settings3.substring(settings3.indexOf("[") + 1, settings3.indexOf("]")).replaceAll('"', ""));
            }
            else {
              localStorage.removeItem("userSettingsIds");
            }

            window.location.replace(window.location.origin + "/menu");
          }
          else if (data2.secret === null || data2.secret === "none") {
            if (data2.full_name !== null && data2.full_name !== undefined) {
              localStorage.setItem("username", data2.full_name);
            }
            else {
              localStorage.removeItem("username");
            }

            if (localStorage.getItem("token") === null) {
              localStorage.setItem("token", token);
            }

            localStorage.setItem("role", data2.role);
            localStorage.setItem("org", data2.orgs[0]);
            localStorage.setItem("orgs", data2.orgs);
            localStorage.setItem("userId", data2.user_id);
            localStorage.setItem("userLanguage", data2.locale.toLowerCase());
            localStorage.setItem("userEmail", data2.email);
            localStorage.setItem("userExpires", data2.expires);
            var settings4 = data2.settings;

            if (settings4 !== null && settings4.substring(settings4.indexOf("[") + 1, settings4.indexOf("[") + 2) === '"') {
              localStorage.setItem("userSettingsIds", settings4.substring(settings4.indexOf("[") + 1, settings4.indexOf("]")).replaceAll('"', ""));
            }
            else {
              localStorage.removeItem("userSettingsIds");
            }

            window.location.replace(window.location.origin + "/menu");
          }
          else {
            // A stored token exists but this account still needs its two-step
            // code verified. logInUserTwoStep() re-runs a full email+password
            // login, so on a fresh page load (no password in memory) the code
            // screen shown here could never succeed. Clear the stale session and
            // send the user through a normal login instead; that reaches the
            // working code screen via logInUser()'s "TwoStepMissing" branch.
            if (passw === "" || passw === null || passw === undefined) {
              localStorage.clear();
              localStorage.setItem("userLanguage", userLanguage);
              sessionStorage.clear();
              window.location.reload();
              return;
            }

            var twoStepLoginContainer = document.getElementById("TwoStepLoginContainer");
            var authFormContainer = document.getElementById("AuthFormContainer");

            if (data2.twostepstyle !== null && twoStepStyle === "none") {
              setTwoStepStyle(data2.twostepstyle);
            }

            loggedIn = true;
            userEmail = data2.email;

            twoStepLoginContainer.setAttribute("style", "display:block");
            authFormContainer.setAttribute("style", "display:none");

          }

        }

      } catch (err) {

        const accountFetchFailedOptions = {
          title: 'Title',
          message: 'Message',
          buttons: [
            {
              label: 'Yes',
              onClick: () => alert('Click Yes')
            },
            {
              label: 'No',
              onClick: () => alert('Click No')
            }
          ],
          childrenElement: () => <div />,
          customUI: ({ title, message, onClose }) =>
            <div className='custom-ui'>
              <h1>{t("local_failed_to_fetch_account_data")} {err}</h1>
              <button className="confirmButton" onClick={onClose}>Ok</button>
            </div>,
          willUnmount: () => {}
        }

        confirmAlert(accountFetchFailedOptions);
      }
    }
  }

  const fetchData = async () => {
    document.getElementById("overlay").style.display = "block";
    await checkUserData();
    document.getElementById("overlay").style.display = "none";
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { languageContext, setLanguageContext } = useContext(LanguageContext);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (userLanguage !== null) {
      i18n.changeLanguage(userLanguage);
    }
  }, [i18n]);

  async function removeTokenAndRefresh() {
    localStorage.clear();
    localStorage.setItem("userLanguage", userLanguage);
    sessionStorage.clear();
    window.location.reload();
  }

  async function removeTokenAndReturnToLogin() {
    await setTwoStepFalse();
    localStorage.clear();
    localStorage.setItem("userLanguage", userLanguage);
    sessionStorage.clear();
    window.location.reload();
  }

  const eulaAcceptFailedOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_failed_to_accept_eula")}</h1>
        <button className="confirmButton" onClick={onClose}>Ok</button>
      </div>,
    willUnmount: () => {}
  }

  const loginFailedOptions2 = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_cannot_login_as_client")}</h1>
        <button className="confirmButton" onClick={onClose}>Ok</button>
      </div>,
    willUnmount: () => {}
  }

  async function acceptEula() {

    try {

      const response = await fetch(baseUrl + "/api/v1/account/" + eulaUserId + "/accept-eula",
      {
        headers: { "Authorization": "Bearer " + eulaToken },
      });

      console.log(response);

      if (response.status === 200) {
        eulaAccepted = true;

        username = eulaUsername;
        token = eulaToken;
        role = eulaRole;
        org = eulaOrg;
        userId = eulaUserId;
        orgs = eulaOrgs;
        localStorage.setItem("userLanguage", eulaLanguage);
        userLanguage = eulaLanguage;
        userEmail = eulaEmail;
        userExpires = eulaExpires;

        if (eulaSettings !== null) {
          userSettingsIds = eulaSettings;
        }

        checkUserData();
      }
      else {
        confirmAlert(eulaAcceptFailedOptions);
      }

    } catch (err) {
      const eulaAcceptFailedOptions2 = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_failed_to_accept_eula")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(eulaAcceptFailedOptions2);
    }
  }

  function changeLanguage(event) {
    i18n.changeLanguage(event.target.value);
    localStorage.setItem("userLanguage", event.target.value);
    setLanguageContext(event.target.value);
  }

  function showCopyright() {
    const copyrightOptions = {
      title: 'Title',
      message: 'Message',
      buttons: [
        {
          label: 'Yes',
          onClick: () => alert('Click Yes')
        },
        {
          label: 'No',
          onClick: () => alert('Click No')
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ title, message, onClose }) =>
        <div className='copyright-custom-ui'>
          <img src={require("../images/Cognituner Logo2.png")} alt="Cognituner" className="copyrightImage" />
          <p>{t("local_licenses")}</p> <br />
          <p>Font Copyright (c) 2017, Julieta Ulanovsky</p>
          <p>with Reserved Font Name Montserrat</p>
          <button className="closeButton" onClick={onClose}>{t("local_close")}</button>
        </div>,
      closeOnClickOutside: false,
      willUnmount: () => {}
    }

    confirmAlert(copyrightOptions);
  }

  const handleKeyPress = (event) => {
    // look for the `Enter` keyCode
    if (event.keyCode === 13 || event.which === 13) {
      logInUser();
    }
  }

  const handleKeyPress2 = (event) => {
    // look for the `Enter` keyCode
    if (event.keyCode === 13 || event.which === 13) {
      logInUserTwoStep();
    }
  }

  const [email, setEmail] = useState("");
  const [passw, setPassw] = useState("");

  async function logInUser() {
    var emailInput = document.getElementById("emailInput");
    var passwordInput = document.getElementById("passwordInput");
    var loginButton = document.getElementById("loginButton");

    emailInput.setAttribute('disabled', '');
    passwordInput.setAttribute('disabled', '');
    loginButton.setAttribute('disabled', '');

    try {

      const response = await fetch(baseUrl + "/api/v1/login/by-email-two-step?email=" + encodeURIComponent(email) + "&pw=" + encodeURIComponent(passw) + "&code=dummy&style=dummy");
      console.log(response);

      const data = await response.json();

      if (data.Message === "TwoStepMissing") {
        var twoStepLoginContainer = document.getElementById("TwoStepLoginContainer");
        var authFormContainer = document.getElementById("AuthFormContainer");

        loggedIn = true;
        setTwoStepStyle(data.TwoStepStyle);
        userEmail = email;

        twoStepLoginContainer.setAttribute("style", "display:block");
        authFormContainer.setAttribute("style", "display:none");
      }
      else if (data.Message !== null && data.Message !== undefined) {
        var errorMessage = t("local_failed_to_login");

        if (data.Message === "AuthError_InvalidCredentials") {
          errorMessage = t("local_login_failed_forbidden_or_unauthorized2");
        }
        else if (data.Message === "AuthError_ExpiredCredentials") {
          errorMessage = t("local_login_failed_credentials_expired2");
        }
        else if (data.Message === "Client_NoConnection") {
          errorMessage = t("local_login_failed_no_connection2");
        }
        else if (data.Message === "AuthError_AccountDeactivated") {
          errorMessage = t("local_login_failed_account_deactivated2");
        }
        else if (data.Message === "AuthError_DeviceMismatch") {
          errorMessage = t("local_login_failed_device_mismatch2");
        }
        else if (data.Message === "AuthError_NoMemberships") {
          errorMessage = t("local_login_failed_no_memberships2");
        }
        else if (data.Message === "AuthError_LicenseExpired") {
          errorMessage = t("local_login_failed_license_expired2");
        }
        else if (data.Message === "Error_Internal") {
          errorMessage = t("local_login_failed_internal_server_error2");
        }

        const loginFailedOptions = {
          title: 'Title',
          message: 'Message',
          buttons: [
            {
              label: 'Yes',
              onClick: () => alert('Click Yes')
            },
            {
              label: 'No',
              onClick: () => alert('Click No')
            }
          ],
          childrenElement: () => <div />,
          customUI: ({ title, message, onClose }) =>
            <div className='login-custom-ui'>
              <h1>{errorMessage}</h1>
              <button className="confirmButton" onClick={onClose}>Ok</button>
            </div>,
          willUnmount: () => {}
        }

        confirmAlert(loginFailedOptions);
      }
      else if (data.account.role === "Client") {
        confirmAlert(loginFailedOptions2);
      }
      else if (data.account.full_name !== null) {

        if (data.account.eula_accepted === null) {
          eulaUserId = data.account.user_id;
          eulaToken = data.token;
          eulaUsername = data.account.full_name;
          eulaRole = data.account.role;
          eulaOrg = data.account.orgs[0];
          eulaOrgs = JSON.stringify(data.account.orgs);
          eulaLanguage = data.account.locale.toLowerCase();
          eulaEmail = data.account.email;
          eulaExpires = data.account.expires;
          var settings2 = data.account.settings;

          if (settings2 !== null && settings2.substring(settings2.indexOf("[") + 1, settings2.indexOf("[") + 2) === '"') {
            eulaSettings = settings2.substring(settings2.indexOf("[") + 1, settings2.indexOf("]")).replaceAll('"', "");
          }
          else {
            eulaSettings = null;
          }

          const eulaAcceptedOptions = {
            title: 'Title',
            message: 'Message',
            buttons: [
              {
                label: 'Yes',
                onClick: () => alert('Click Yes')
              },
              {
                label: 'No',
                onClick: () => alert('Click No')
              }
            ],
            childrenElement: () => <div />,
            customUI: ({ title, message, onClose }) =>
              <div className='eula-custom-ui'>
                <img src={require("../images/Cognituner Logo2.png")} alt="Cognituner" className="eulaImage" />
                { languageContext === "en" ? (
                  <embed id="eulaText" className="eulaText" src={require("../eula/EULA_EN.txt")} />
                ) : languageContext === "fi" ? (
                  <embed id="eulaText" className="eulaText" src={require("../eula/EULA_FI.txt")} />
                ) : (
                  <embed id="eulaText" className="eulaText" src={require("../eula/EULA_EN.txt")} />
                )}
                <button className="confirmButton" onClick={() => {acceptEula(); onClose();}}>{t("local_eula_button_accept")}</button>
                <button className="confirmButton" onClick={onClose}>{t("local_eula_button_decline")}</button>
              </div>,
            closeOnClickOutside: false,
            willUnmount: () => {}
          }

          confirmAlert(eulaAcceptedOptions);
        }
        else {
          eulaAccepted = true;
        }

        if (eulaAccepted === true) {
          username = data.account.full_name;
          token = data.token;
          role = data.account.role;
          org = data.account.orgs[0];
          orgs = JSON.stringify(data.account.orgs);
          userId = data.account.user_id;
          localStorage.setItem("userLanguage", data.account.locale.toLowerCase());
          userLanguage = data.account.locale.toLowerCase();
          userEmail = data.account.email;
          userExpires = data.account.expires;

          var settings = data.account.settings;

          if (settings !== null && settings.substring(settings.indexOf("[") + 1, settings.indexOf("[") + 2) === '"') {
            userSettingsIds = settings.substring(settings.indexOf("[") + 1, settings.indexOf("]")).replaceAll('"', "");
          }
          else {
            userSettingsIds = null;
          }

          checkUserData();

        }

      }
    } catch (err) {
      const loginFailedOptions3 = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_failed_to_login")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(loginFailedOptions3);
    }

    emailInput.removeAttribute('disabled');
    passwordInput.removeAttribute('disabled');
    loginButton.removeAttribute('disabled');
  }

  function sendEmail() {
    localStorage.setItem("forgotEmail", email);
  }

  async function setTwoStepFalse() {
    if (userId !== undefined && userId !== null && token !== undefined && token !== null) {
      // Don't write the account back unless we actually have its loaded name.
      // On the two-step screen the user hasn't finished logging in, so the
      // module-level `username` is still null; POSTing here would send the
      // string "null" and overwrite the real full_name.
      if (!accountNameLoaded(username)) {
        return;
      }

      document.getElementById("overlay").style.display = "block";

      var jsonBody = buildAccountJsonBody({
        user_id: userId,
        twostep: false,
        email: userEmail,
        full_name: username,
        expires: (userExpires === "null" || userExpires === null) ? null : userExpires,
        locale: userLanguage.toUpperCase(),
        role: role,
        active: true,
        settings: JSON.stringify({
          RestrictToRecipes: false,
          Pros: buildProsArray(userId, userSettingsIds),
        }),
        orgs: buildOrgsArray(org, orgs),
      });

      try {
        const response = await fetch(baseUrl + "/api/v1/account/" + userId, {
          method: "POST",
          headers: { "Authorization": "Bearer " + token, "Content-Type": 'application/json' },
          body: jsonBody,
        });

        console.log(response);

        if (response.status === 200) {
        }
        else if (response.status === 500) {
          const twoStepVerifyFailedOptions2 = {
            title: 'Title',
            message: 'Message',
            buttons: [
              {
                label: 'Yes',
                onClick: () => alert('Click Yes')
              },
              {
                label: 'No',
                onClick: () => alert('Click No')
              }
            ],
            childrenElement: () => <div />,
            customUI: ({ title, message, onClose }) =>
              <div className='custom-ui'>
                <h1>{t("local_two_step_verify_failed")}</h1>
                <button className="confirmButton" onClick={onClose}>Ok</button>
              </div>,
            closeOnClickOutside: false,
            willUnmount: () => {}
          }

          confirmAlert(twoStepVerifyFailedOptions2);
        }
        else {
          const data = await response.json();

          if (data.Message !== null && data.Message !== undefined) {
            var errorMessage = data.Message;

            if (data.Message === "Error_EmailExists") {
              errorMessage = t("local_api_result_error_email_exists");
            }
            else if (data.Message === "Error_UserLimitReached") {
              errorMessage = t("local_api_result_error_user_limit_reached");
            }
            else if (data.Message === "Error_UserNameExists") {
              errorMessage = t("local_api_result_error_user_name_exists");
            }
            else if (data.Message === "Error_Internal") {
              errorMessage = t("local_api_result_error_internal");
            }
            else if (data.Message === "Error_ResourceNotFound") {
              errorMessage = t("local_api_result_error_resource_not_found");
            }
            else if (data.Message === "Error_UnauthorizedAccess") {
              errorMessage = t("local_api_result_error_unauthorized_access");
            }
            else if (data.Message === "Error_InvalidBody") {
              errorMessage = t("local_api_result_error_invalid_body");
            }
            else if (data.Message === "Error_ValidationFailed") {
              errorMessage = t("local_api_result_error_validation_failed");
            }
            else if (data.Message === "Error_InvalidRequest") {
              errorMessage = t("local_api_result_error_invalid_request");
            }
            else if (data.Message === "Error_InsufficientPermissions") {
              errorMessage = t("local_api_result_error_insufficient_permissions");
            }
            else if (data.Message === "Error_InvalidEmail") {
              errorMessage = t("local_api_result_error_invalid_email");
            }
            else if (data.Message === "Error_AlreadyExists") {
              errorMessage = t("local_api_result_error_already_exists");
            }
            else if (data.Message === "Unknown") {
              errorMessage = t("local_api_result_unknown");
            }

            if (data.Message === "AuthError_InvalidAccessToken") {
              confirmAlert(tokenExpiredOptions);
            }
            else {
              const userCreationFailedOptions = {
                title: 'Title',
                message: 'Message',
                buttons: [
                  {
                    label: 'Yes',
                    onClick: () => alert('Click Yes')
                  },
                  {
                    label: 'No',
                    onClick: () => alert('Click No')
                  }
                ],
                childrenElement: () => <div />,
                customUI: ({ title, message, onClose }) =>
                  <div className='custom-ui'>
                    <h1>{errorMessage}</h1>
                    <button className="confirmButton" onClick={onClose}>Ok</button>
                  </div>,
                willUnmount: () => {}
              }

              confirmAlert(userCreationFailedOptions);
            }

          }
        }

        document.getElementById("overlay").style.display = "none";

      } catch (err) {
        document.getElementById("overlay").style.display = "none";

        const userCreationFailedOptions2 = {
          title: 'Title',
          message: 'Message',
          buttons: [
            {
              label: 'Yes',
              onClick: () => alert('Click Yes')
            },
            {
              label: 'No',
              onClick: () => alert('Click No')
            }
          ],
          childrenElement: () => <div />,
          customUI: ({ title, message, onClose }) =>
            <div className='custom-ui'>
              <h1>{t("local_user_edit_failed2")} {err}</h1>
              <button className="confirmButton" onClick={onClose}>Ok</button>
            </div>,
          willUnmount: () => {}
        }

        confirmAlert(userCreationFailedOptions2);
      }
    }

  }

  async function sendTwoStepMail() {

    if (loggedIn === true) {
      try {
        document.getElementById("overlay").style.display = "block";

        const response = await fetch(baseUrl + "/api/v1/login/2fa-email?email=" + encodeURIComponent(userEmail));
        console.log(response);

        document.getElementById("overlay").style.display = "none";

        if (response.status === 200) {
          confirmAlert(authEmailSentOptions);
        }
        else {
          confirmAlert(authEmailFailedOptions);
        }
      } catch (err) {
        document.getElementById("overlay").style.display = "none";

        const authEmailFailedOptions2 = {
          title: 'Title',
          message: 'Message',
          buttons: [
            {
              label: 'Yes',
              onClick: () => alert('Click Yes')
            },
            {
              label: 'No',
              onClick: () => alert('Click No')
            }
          ],
          childrenElement: () => <div />,
          customUI: ({ title, message, onClose }) =>
            <div className='custom-ui'>
              <h1>{t("local_failed_to_send_auth_email")} {err}</h1>
              <button className="confirmButton" onClick={onClose}>Ok</button>
            </div>,
          willUnmount: () => {}
        }

        confirmAlert(authEmailFailedOptions2);
      }
    }

  }

  async function logInUserTwoStep() {
    document.getElementById("overlay").style.display = "block";

    if (loggedIn === true) {
      try {
        var code = verificationCode.replaceAll(/ /g, "");

        if (verificationCode === null || verificationCode === "" || verificationCode === undefined) {
          code = "dummy";
        }

        const response = await fetch(baseUrl + "/api/v1/login/by-email-two-step?email=" + encodeURIComponent(email) + "&pw=" + encodeURIComponent(passw) + "&code=" + encodeURIComponent(code) + "&style=" + encodeURIComponent(twoStepStyle));
        console.log(response);

        const data = await response.json();

        if (data.Message === "TwoStepMissing") {
          document.getElementById("overlay").style.display = "none";

          const twoStepVerifyFailedOptions = {
            title: 'Title',
            message: 'Message',
            buttons: [
              {
                label: 'Yes',
                onClick: () => alert('Click Yes')
              },
              {
                label: 'No',
                onClick: () => alert('Click No')
              }
            ],
            childrenElement: () => <div />,
            customUI: ({ title, message, onClose }) =>
              <div className='custom-ui'>
                <h1>{t("local_two_step_verify_failed")}</h1>
                <button className="confirmButton" onClick={onClose}>Ok</button>
              </div>,
            closeOnClickOutside: false,
            willUnmount: () => {}
          }

          confirmAlert(twoStepVerifyFailedOptions);
        }
        else if (data.Message !== null && data.Message !== undefined) {
          var errorMessage = t("local_failed_to_login");

          if (data.Message === "AuthError_InvalidCredentials") {
            errorMessage = t("local_login_failed_forbidden_or_unauthorized2");
          }
          else if (data.Message === "AuthError_ExpiredCredentials") {
            errorMessage = t("local_login_failed_credentials_expired2");
          }
          else if (data.Message === "Client_NoConnection") {
            errorMessage = t("local_login_failed_no_connection2");
          }
          else if (data.Message === "AuthError_AccountDeactivated") {
            errorMessage = t("local_login_failed_account_deactivated2");
          }
          else if (data.Message === "AuthError_DeviceMismatch") {
            errorMessage = t("local_login_failed_device_mismatch2");
          }
          else if (data.Message === "AuthError_NoMemberships") {
            errorMessage = t("local_login_failed_no_memberships2");
          }
          else if (data.Message === "AuthError_LicenseExpired") {
            errorMessage = t("local_login_failed_license_expired2");
          }
          else if (data.Message === "Error_Internal") {
            errorMessage = t("local_login_failed_internal_server_error2");
          }

          document.getElementById("overlay").style.display = "none";

          const loginFailedOptions = {
            title: 'Title',
            message: 'Message',
            buttons: [
              {
                label: 'Yes',
                onClick: () => alert('Click Yes')
              },
              {
                label: 'No',
                onClick: () => alert('Click No')
              }
            ],
            childrenElement: () => <div />,
            customUI: ({ title, message, onClose }) =>
              <div className='login-custom-ui'>
                <h1>{errorMessage}</h1>
                <button className="confirmButton" onClick={onClose}>Ok</button>
              </div>,
            willUnmount: () => {}
          }

          confirmAlert(loginFailedOptions);
        }
        else if (data.account.role === "Client") {
          document.getElementById("overlay").style.display = "none";

          confirmAlert(loginFailedOptions2);
        }
        else if (data.account.full_name !== null) {

          if (data.account.eula_accepted === null) {
            eulaUserId = data.account.user_id;
            eulaToken = data.token;
            eulaUsername = data.account.full_name;
            eulaRole = data.account.role;
            eulaOrg = data.account.orgs[0];
            eulaOrgs = JSON.stringify(data.account.orgs);
            eulaLanguage = data.account.locale.toLowerCase();
            eulaEmail = data.account.email;
            eulaExpires = data.account.expires;
            var settings2 = data.account.settings;

            if (settings2 !== null && settings2.substring(settings2.indexOf("[") + 1, settings2.indexOf("[") + 2) === '"') {
              eulaSettings = settings2.substring(settings2.indexOf("[") + 1, settings2.indexOf("]")).replaceAll('"', "");
            }
            else {
              eulaSettings = null;
            }

            document.getElementById("overlay").style.display = "none";

            const eulaAcceptedOptions = {
              title: 'Title',
              message: 'Message',
              buttons: [
                {
                  label: 'Yes',
                  onClick: () => alert('Click Yes')
                },
                {
                  label: 'No',
                  onClick: () => alert('Click No')
                }
              ],
              childrenElement: () => <div />,
              customUI: ({ title, message, onClose }) =>
                <div className='eula-custom-ui'>
                  <img src={require("../images/Cognituner Logo2.png")} alt="Cognituner" className="eulaImage" />
                  { languageContext === "en" ? (
                    <embed id="eulaText" className="eulaText" src={require("../eula/EULA_EN.txt")} />
                  ) : languageContext === "fi" ? (
                    <embed id="eulaText" className="eulaText" src={require("../eula/EULA_FI.txt")} />
                  ) : (
                    <embed id="eulaText" className="eulaText" src={require("../eula/EULA_EN.txt")} />
                  )}
                  <button className="confirmButton" onClick={() => {acceptEula(); onClose();}}>{t("local_eula_button_accept")}</button>
                  <button className="confirmButton" onClick={onClose}>{t("local_eula_button_decline")}</button>
                </div>,
              closeOnClickOutside: false,
              willUnmount: () => {}
            }

            confirmAlert(eulaAcceptedOptions);
          }
          else {
            eulaAccepted = true;
          }

          if (eulaAccepted === true) {
            username = data.account.full_name;
            token = data.token;
            role = data.account.role;
            org = data.account.orgs[0];
            orgs = JSON.stringify(data.account.orgs);
            userId = data.account.user_id;
            localStorage.setItem("userLanguage", data.account.locale.toLowerCase());
            userLanguage = data.account.locale.toLowerCase();
            userEmail = data.account.email;
            userExpires = data.account.expires;

            var settings = data.account.settings;

            if (settings !== null && settings.substring(settings.indexOf("[") + 1, settings.indexOf("[") + 2) === '"') {
              userSettingsIds = settings.substring(settings.indexOf("[") + 1, settings.indexOf("]")).replaceAll('"', "");
            }
            else {
              userSettingsIds = null;
            }

            document.getElementById("overlay").style.display = "none";

            checkUserData();

          }

        }
      } catch (err) {
        document.getElementById("overlay").style.display = "none";

        const loginFailedOptions3 = {
          title: 'Title',
          message: 'Message',
          buttons: [
            {
              label: 'Yes',
              onClick: () => alert('Click Yes')
            },
            {
              label: 'No',
              onClick: () => alert('Click No')
            }
          ],
          childrenElement: () => <div />,
          customUI: ({ title, message, onClose }) =>
            <div className='custom-ui'>
              <h1>{t("local_failed_to_login")} {err}</h1>
              <button className="confirmButton" onClick={onClose}>Ok</button>
            </div>,
          willUnmount: () => {}
        }

        confirmAlert(loginFailedOptions3);
      }
    }
  }

  setTimeout( function() {
    var authApp = document.getElementById("authApp");
    var authEmail = document.getElementById("authEmail");

    if (authApp !== undefined && authApp !== null &&
      authEmail !== undefined && authEmail !== null) {
      if (twoStepStyle === "email") {
        authEmail.checked = true;
      }
      else if (twoStepStyle === "auth") {
        authApp.checked = true;
      }
    }
  }, 10);

  return (
    <div className="Auth-container">

      <div id="AuthFormContainer" className="AuthFormContainer">
        <form action="" className="Auth-form">
          <img src={require("../images/Cognituner Logo2.png")} alt="Sign in" className="Auth-form-img" />

          <div className="Auth-form-login" disabled>
            <div className="Auth-form-input">
              <input
                type="email"
                id="emailInput"
                className="form-control mt-1"
                placeholder={t("local_enter_email")}
                value={email}
                onChange={(e)=>setEmail(e.target.value)}
              />
              <input
                type="password"
                id="passwordInput"
                className="form-control mt-2"
                placeholder={t("local_enter_password")}
                value={passw}
                onChange={(e)=>setPassw(e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
            <button id="loginButton" type="button" className="btn btn-primary btn-login" onClick={logInUser} >
              {t("local_login")}
            </button>
          </div>
          <p className="forgot-password text-right mt-3">
            <a href="./forgotemail" onClick={sendEmail}>{t("local_forgot_password")}</a>
          </p>
        </form>
        <div className ="loginRightDiv">
          <button id="copyrightButton" type="button" className="btn btn-primary btn-copyright" onClick={showCopyright} >
            {t("local_button_about_copyright")}
          </button>
          <select id="loginLanguageSelect" name="loginLanguageSelect" className="loginLanguageSelect" defaultValue={userLanguage} onChange={(event) => changeLanguage(event)}>
            <option value="en">{t("local_english")}</option>
            <option value="fi">{t("local_finnish")}</option>
            <option value="se">{t("local_swedish")}</option>
          </select>
        </div>

      </div>

      <div id="TwoStepLoginContainer" className="TwoStepLoginContainer">
        <div className="TwoStepLogin-form-container">
          <h1>{t("local_give_verification_code")}</h1>
          <br /> <br />
          <input
            id="verificationCode"
            label="Verification code"
            type="text"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            autoComplete="off"
            onKeyPress={handleKeyPress2}
          />

          <button type="button" onClick={logInUserTwoStep}>{t("local_confirm")}</button>
          <br />

          <div id="twoStepEmailRadioButtonGroup" className="twoStepEmailRadioButtonGroup">
            <p className="radioButtonGroupHeader">{t("local_choose_two_step")}</p>
            <input className="radioButton" type="radio" id="authApp" name="authStyleRadio" value="App" onChange={() => setAuthStyle(setTwoStepStyle, twoStepStyle)} />
            <label className="radioButtonLabel" htmlFor="authApp">{t("local_app")}</label><br />
            <input className="radioButton" type="radio" id="authEmail" name="authStyleRadio" value="Email" onChange={() => setAuthStyle(setTwoStepStyle, twoStepStyle)} />
            <label className="radioButtonLabel" htmlFor="authEmail">{t("local_email")}</label><br />
          </div>

          <button className="btn btn-primary btn-sendAuthEmail2" onClick={sendTwoStepMail}>
            {t("local_send_auth_email")}
          </button>

          <button className="btn btn-primary btn-return-to-login" onClick={removeTokenAndReturnToLogin}>
            {t("local_return_to_login")}
          </button>
        </div>

      </div>

      <div id="overlay">
        <div className="Loading-icon-div">
          <img src={require("../images/loading-icon.png")} className="Loading-icon" alt = "Loading..." border = "0"/>
        </div>
      </div>
    </div>
  )
}

export default Authoritize;